module.exports = __webpack_public_path__ + "static/media/fruit.5e9b198f.png";